<template>
  <b-container label="Actualizar Datos">
    <b-row>
      <b-col>
        <b-form-group label="Capacidad AM" class="mb-2">
          <b-form-input
            number
            v-model="selectedHolidayObject.morningDisponibility"
          />
        </b-form-group>
        <b-form-group label="Tipo Vigencia" class="mb-1">
          <b-form-select
            :options="validityTypeOptions"
            v-model="selectedHolidayObject.isAllDay"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Capacidad PM" class="mb-1">
          <b-form-input
            number
            type="number"
            v-model="selectedHolidayObject.eveningDisponibility"
          />
        </b-form-group>
        <b-form-group label="Descripción" class="mb-1">
          <b-form-input
            v-model="selectedHolidayObject.description"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="selectedHolidayObject.isAllDay !== 'true'">
      <b-col>
        <b-form-group label="Inicio" class="mb-1">
          <b-form-select
            :options="hourOptions"
            v-model="selectedHolidayObject.initialTime"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Almuerzo" class="mb-1">
          <b-form-select
            :options="hourOptions"
            v-model="selectedHolidayObject.lunchTime"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Cierre" class="mb-1">
          <b-form-select
            :options="hourOptions"
            v-model="selectedHolidayObject.finalTime"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Fecha inicio">
          <b-form-datepicker
            v-model="selectedHolidayObject.initialDate"
          ></b-form-datepicker>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Fecha término">
          <b-form-datepicker
            v-model="selectedHolidayObject.finalDate"
          ></b-form-datepicker>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-form-group label="Empresa" class="mb-1">
          <b-form-select
            :options="companyOptions"
            v-model="company"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Sucursales" class="mb-1">
          <b-form-checkbox v-model="selectAllLocations">Todas</b-form-checkbox>
          <b-form-select
            multiple
            :options="options"
            v-model="selectedHolidayObject.locations"
            :select-size="5"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import {
  BCardBody,
  BFormSelect,
  BFormGroup,
  BRow,
  BCol,
  BContainer,
  BFormInput,
  BFormCheckbox,
  BFormDatepicker,
} from 'bootstrap-vue'
import DatePicker from 'vue2-datepicker'
import VueElementLoading from 'vue-element-loading'

export default {
  components: {
    BCardBody,
    BFormSelect,
    VueElementLoading,
    BFormGroup,
    BRow,
    BCol,
    BContainer,
    BFormCheckbox,
    BFormInput,
    BFormDatepicker,
    DatePicker,
  },
  data() {
    return {
      selectedHolidayObject: {
        morningDisponibility: 0,
        isAllDay: null,
        eveningDisponibility: 0,
        initialTime: '08:00',
        lunchTime: '08:00',
        finalTime: '08:00',
        initialDate: new Date(),
        finalDate: new Date(),
        locations: [],
        description: ''
      },
      selectAllLocations: false,
      initialDate: null,
      finalDate: null,
      options: [],
      companyOptions: [
        {value: 'OLX', text: 'OLX'},
        {value: 'clicar', text: 'Clicar'},
        {value: 'wigo', text: 'Wigo'},
      ],
      allLocations: [],
      company: 'OLX',
      hourOptions: [
        { value: '07:00', text: '07:00' },
        { value: '08:00', text: '08:00' },
        { value: '09:00', text: '09:00' },
        { value: '10:00', text: '10:00' },
        { value: '11:00', text: '11:00' },
        { value: '12:00', text: '12:00' },
        { value: '13:00', text: '13:00' },
        { value: '14:00', text: '14:00' },
        { value: '15:00', text: '15:00' },
        { value: '16:00', text: '16:00' },
        { value: '17:00', text: '17:00' },
        { value: '18:00', text: '18:00' },
        { value: '19:00', text: '19:00' },
        { value: '20:00', text: '20:00' },
        { value: '21:00', text: '21:00' },
      ],
      validityTypeOptions: [
        { value: null, text: 'Seleccione...' },
        { value: 'true', text: 'Completa' },
        { value: 'false', text: 'Parcial' },
      ],
      answers: [],
      dateRange: [],
    }
  },
  watch: {
    selectedHolidayObject: {
      handler(newValue) {
        /* if(this.newValue.isAllDay === 'true'){
          this.newValue.initialDate = null
          this.newValue.finalDate = null
          this.newValue.lunchTime = null
        } */
        this.setHolidayForm(newValue)
      },
      deep: true,
    },
    selectAllLocations: {
      handler(newValue){
        if(newValue){
          this.selectedHolidayObject.locations = this.options.map(option => {
            const { value} = option
            return value
          })
        }else{
          this.selectedHolidayObject.locations = []
        }
      }
    },
    company: {
      handler(newValue){
        this.selectedHolidayObject.locations = []
        this.setLocationOptions(this.allLocations)
      }
    }
  },
  computed: {
  },
  methods: {
    ...mapActions('locations', ['getLocations']),
    ...mapMutations('holidays', ['setHolidayForm']),
    ...mapMutations('tableFilters', ['setInput', 'setSelectedCompany']),
    setLocationOptions(locations) {
      this.options = locations.filter(location => location.company === this.company).map((location) => {
        return {
          value: location.id,
          text: location.name,
        }
      })
    },
  },
  created() {
    this.setSelectedCompany('olx,clicar,wigo')
    this.getLocations({paginated: false, options: true})
      .then((result) => {
        console.log(result)
        this.allLocations = result.data
        this.setLocationOptions(result.data)
      })
  },
}
</script>
